<div class="position-relative" *ngIf="pvsHtml">
    <div  [innerHtml]="pvsHtml"></div>
</div>